import { useTheme } from '@chakra-ui/react'
import { CheckIcon } from '@verbit-ai/icons-library'

import { analyticsService } from 'src/services/AnalyticsService'
import { getLanguagePresentation } from 'src/utils/language'
import { useLanguage } from 'src/contexts/LanguageContext'

import * as S from './styles'

export const LanguagesList = () => {
    const {
        palette: {
            languageSelect: { iconColor },
        },
    } = useTheme()
    const { requestLanguage, originalLanguageCode, requestedLanguageCode, translations, isOriginalLanguage } = useLanguage()

    const onLanguageSelected = (languageCode: string) => {
        analyticsService.track('TranslationLanguageSelected', {
            source: originalLanguageCode,
            target: languageCode,
        })

        requestLanguage(languageCode)
    }

    return (
        <S.Panel>
            <S.DefaultLanguage>
                <S.TextContent>{getLanguagePresentation(originalLanguageCode, translations)}</S.TextContent>
                {isOriginalLanguage && <CheckIcon color={iconColor} />}
            </S.DefaultLanguage>
            <S.HeightLimiter>
                <S.LanguageOptionList role="list">
                    {translations.map(({ name, code }) => {
                        const isSelected = code === requestedLanguageCode

                        return (
                            <S.LanguageOptionItem key={code}>
                                <S.LanguageButton aria-pressed={isSelected} onClick={() => onLanguageSelected(code)}>
                                    <S.TextContent>{name}</S.TextContent>
                                    {isSelected && <CheckIcon color={iconColor} aria-hidden />}
                                </S.LanguageButton>
                            </S.LanguageOptionItem>
                        )
                    })}
                </S.LanguageOptionList>
            </S.HeightLimiter>
        </S.Panel>
    )
}
